import AbsModule from '../common/AbsModule';
import { lnbMarkup } from '../common/LnbCommon';
import PurpleUrl from '../purple/PurpleUrl';

class Lnb extends AbsModule {
    startSetting() {
        const { lnbCallbackMap } = this.moduleData || {};
        const { isPurpleApp } = this.com?.purpleCheck || {};

        // onClick 콜백 실행
        const callbackItems = document.querySelectorAll('#nc-cnb .ncc-lnb-m [data-callback]');
        callbackItems?.forEach(item => {
            item?.addEventListener('click', e => {
                e.preventDefault();

                const target = e.currentTarget;
                const callbackKey = target?.dataset?.callback;
                const callback = lnbCallbackMap.get(callbackKey);
                
                // callback 실행
                if(typeof callback === 'function') {
                    callback(e);
                }

                return false;
            });
        });

        // 퍼플 모바일(인앱)일 때, 외부 브라우저 띄우기
        if(isPurpleApp) {
            const externalItems = document.querySelectorAll('#nc-cnb .ncc-lnb-m [data-type="external"]');
            externalItems?.forEach(item => {
                item?.addEventListener('click', e => {
                    e.preventDefault();
                    
                    const url = e?.currentTarget?.href;
                    PurpleUrl.goPurpleAppExternal(url); // 외부 브라우저로 이동
    
                    return false;
                });
            });
        }
    }

    makeMarkup() {
        const { lnbData, active } = this.moduleData || {};

        return `<nav class="ncc-lnb-m">
            ${lnbMarkup({
                lnbData, 
                isSub: false, 
                active
            })}
        </nav>`;
    }
}

export default Lnb;